<svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <title>Sun</title>
    <circle fill="currentColor" cx="12" cy="12" r="4"></circle>
    <path d="M12 2v2"></path>
    <path d="M12 20v2"></path>
    <path d="M5 5l1.5 1.5"></path>
    <path d="M17.5 17.5L19 19"></path>
    <path d="M2 12h2"></path>
    <path d="M20 12h2"></path>
    <path d="M5 19l1.5-1.5"></path>
    <path d="M17.5 6.5L19 5"></path>
</svg>
